import CustomWebView from '@/components/CustomWebView';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { acceptTermsRequest } from '@/store/identity/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
import './terms-whitelabel-style.scss';

interface Props {
    handleModalClose?: () => void;
}
const TermsOfUseWhiteLabel: React.FC<Props> = ({ handleModalClose }: Props) => {
    const dispatch = useDispatch();

    const [buttonVisible, setButtonVisible] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [termsUrl, setTermsUrl] = useState<string>();

    const { strings, personId, termsAccepted } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        personId: state.identity.data.person.id || 0,
        termsAccepted: state.identity.data.person.termsAccepted,
    }));

    useEffect(() => {
        let prefix = '/';

        const { hostname, pathname } = window.location;
        if (process.env.NODE_ENV === 'production' && hostname.includes(Constants.DOMAIN)) {
            prefix = pathname;
        }

        setTermsUrl(`${prefix}eula/${strings._LANGUAGE === Constants.language.PT ? 'pt_br' : 'en_us'}.html`);
    }, [strings._LANGUAGE]);

    useEffect(() => {
        if (termsAccepted && handleModalClose) {
            handleModalClose();
        }
    }, [termsAccepted]);

    const acceptTermsOfUse = () => {
        setButtonDisabled(true);
        dispatch(acceptTermsRequest(personId));
    };

    return (
        <div className="terms-of-use">
            {termsUrl && (
                <CustomWebView
                    maxHeight={450}
                    onLoad={() => setButtonVisible(true)}
                    onScrollEnd={() => setButtonDisabled(false)}
                    percentualToEnd={99}
                    uri={termsUrl}
                />
            )}
            {buttonVisible && (
                <button className={`btn btn-primary btn-block terms-button`} disabled={buttonDisabled} onClick={acceptTermsOfUse} type="button">
                    <span>{strings.ACCEPT_TERMS}</span>
                </button>
            )}
        </div>
    );
};

export default TermsOfUseWhiteLabel;
